/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { updatePlaylist, readPlaylistForUser, readClips } from '../../lib/PlaylistApi'

export const saveClipToProfile = (gameId, user, clip, tags, cb) => {
    return (dispatch, getState) => {
        let gameClip = null
        let clipTags = []
        for (let tag of tags) {
            clipTags.push({
                name: tag,
            })
        }

        readClips(gameId)
            .then(json => {
                for (let event of json) {
                    if (event.utc_time === clip.utc_time) {
                        gameClip = event
                        break
                    }
                }
                return
            })
            .then(() => {
                return readPlaylistForUser(user)
            })
            .then(playlist => {
                console.log('gameClip', gameClip)
                console.log('playlist', playlist)
                console.log('tags', tags)

                gameClip.tags = clipTags
                if (clip._spotlights) {
                    gameClip._spotlights = clip._spotlights
                }
                playlist.clips.push(gameClip)
                console.log('playlist to update', playlist)
                return updatePlaylist(playlist)
            })
            .then(updatedPlaylist => {
                console.log('updatedPlaylist', updatedPlaylist)
                let game = getState().game.value
                for (let clip of updatedPlaylist.clips) {
                    for (let event of game.events) {
                        if (clip.game_clip_id === event.game_clip_id) {
                            event.user_playlist_key = updatedPlaylist.hash_key
                            event.playlist_clip_id = clip.playlist_clip_id
                        }
                    }
                }
                dispatch({
                    type: 'COMMON_SET',
                    key: 'game',
                    value: game,
                    error: null,
                    complete: true,
                    loading: false,
                    note: 'save clip update',
                })
                if (cb) { cb(true) }
            })
            .catch(e => {
                console.error(e)
                if (cb) { cb(false) }
            })
    }
}


export const deleteClipFromPlaylist = (user, gameClip, cb) => {
    return (dispatch, getState) => {
        readPlaylistForUser(user).then(playlist => {
            console.log('gameClip', gameClip)
            console.log('playlist', playlist)

            console.log('playlist to update', playlist)
            for (let idx in playlist.clips) {
                if (playlist.clips[idx].game_clip_id === gameClip.game_clip_id) {
                    console.log(`Removing clip ${gameClip.game_clip_id} for user ${user.user_id}`, idx)
                    playlist.clips.splice(idx, 1)
                }
            }
            return updatePlaylist(playlist)
        }).then(updatedPlaylist => {
            console.log('updatedPlaylist', updatedPlaylist)
            let game = getState().game.value
            for (let event of game.events) {
                if (gameClip.game_clip_id === event.game_clip_id) {
                    event.user_playlist_key = undefined
                    event.playlist_clip_id = undefined
                }
            }
            dispatch({
                type: 'COMMON_SET',
                key: 'game',
                value: game,
                error: null,
                complete: true,
                loading: false,
                note: 'save clip update',
            })
            if (cb) {
                cb(true)
            }
        }).catch(e => {
            console.error(e)
            if (cb) {
                cb(false)
            }
        })
    }
}

